import { AxiosService } from './axios.service'

const baseURL = 'bilhete'

/**
 * Defines the API methods for ticket consult
 */
export default class TicketConsultService {
	/**
	 * Consult the trip tickets
	 * @return {Promise<any>} The ticket sale items
	 */
	static consultTickets(orderId) {
		return AxiosService.get(`${baseURL}/${orderId}`).then(({ data }) => data)
	}
}
